import { useReactiveVar } from '@apollo/client';
import { useLocation } from 'react-router-dom';

import ROUTES from '@/routes/routes';
import { UserRoleEnum } from '@/types/graphql';
import { currentAdminVar } from '@/util/apollo/cache';

// Which dashboard the sidebar's "Dashboard" entry opens, and what "/" resolves
// to (GRAVY-10832). Dashboard V2 for tenant admins, the classic one for
// everybody else — there is no preference and nothing stored: the only way back
// to V1 is the explicit link on the Dashboard V2 page, and the sidebar is the
// way back to V2.
const useDashboardRoute = () => {
  const currentAdmin = useReactiveVar(currentAdminVar);
  const { pathname } = useLocation();

  // Deliberately `user.roleId`, not useAuth's `currentAdmin.role`: this must
  // match PrivateRoute's own check on the `/dashboard-v2` route exactly, or we
  // would point the sidebar at a page that bounces the admin to /orders.
  // Dashboard V2 is TENANT_ADMIN only on both halves — the route and
  // `require_tenant_admin` on API::Admin::DashboardV2::BaseController.
  const isDashboardV2Admin =
    currentAdmin?.user?.roleId === UserRoleEnum.TENANT_ADMIN;

  // While the admin is on the classic dashboard, "Dashboard" points AT the
  // classic dashboard. Two reasons, and the second is the real one:
  //
  //  1. the Figma keeps the sidebar entry highlighted there, and NavLink only
  //     highlights the route it points at — aiming it at /dashboard-v2 from
  //     /dashboard-v1 leaves the whole sidebar with nothing selected;
  //  2. the header switch is now the way between the two, so the sidebar no
  //     longer has to double as the escape hatch back to V2.
  const onDashboardV1 = pathname === `/${ROUTES.dashboardV1}`;

  const dashboardPath = !isDashboardV2Admin
    ? ROUTES.basePath
    : onDashboardV1
      ? `/${ROUTES.dashboardV1}`
      : `/${ROUTES.dashboardV2}`;

  return { isDashboardV2Admin, dashboardPath };
};

export default useDashboardRoute;
